import Service, { ServiceClassProps } from './Service';

export type DbServiceClassProps = {};

export interface DbServiceInterface {}

export default class DbService extends Service implements DbServiceInterface {
    // constructor(props: ServiceClassProps) {
    //   super(props);
    // }
}
